var map = {
	"./development.js": "./server/config/environment/development.js",
	"./index.js": "./server/config/environment/index.js",
	"./production.js": "./server/config/environment/production.js",
	"./qa copy.js": "./server/config/environment/qa copy.js",
	"./qa.js": "./server/config/environment/qa.js",
	"./shared.js": "./server/config/environment/shared.js",
	"./test.js": "./server/config/environment/test.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./server/config/environment sync recursive ^\\.\\/.*\\.js$";